import React, { useState, useEffect } from 'react';
import { Button } from 'selfly-ui-react/dist/components/';

import InnerSpinner from '../Loading/InnerSpinner';

import { JOKI } from '../../JOKI';
import ConfirmButton from '../ConfirmButton/ConfirmButton';

export default function CrudEditContainer({ crudState, crudDispatch, ...props }) {
    const [fullItem, setFullItem] = useState('LOADING');
    const [error, setError] = useState(null);
    const [saving, setSaving] = useState(false);
    const [formIsValid, setFormIsValid] = useState(false);

    useEffect(() => {
        async function getFullCrudItem(item) {
            const results = await JOKI.ask({
                from: 'React:CrudNewContainer',
                to: crudState.serviceId,
                key: 'getFullCrudItem',
                body: item,
            });

            if (results && results[crudState.serviceId].then !== undefined) {
                results[crudState.serviceId]
                    .then(res => {
                        setFullItem(res);
                    })
                    .catch(err => {
                        setError(err);
                        setFullItem(null);
                    });
            } else {
                if (results && results[crudState.serviceId]) {
                    setFullItem(results[crudState.serviceId]);
                }
            }
        }
        getFullCrudItem(crudState.item);
        // eslint-disable-next-line
    }, []);

    function onCancel() {
        crudDispatch({ type: crudState.backTo || 'list' });
    }

    function onSave() {
        setSaving(true);

        JOKI.trigger({
            from: 'React:CrudEditContainer',
            to: crudState.serviceId,
            key: 'crudUpdateItem',
            body: fullItem,
        });
        crudDispatch({ type: crudState.backTo || 'list' });
    }

    function onDelete() {
        setSaving(true);
        JOKI.trigger({
            from: 'React:CrudEditContainer',
            to: crudState.serviceId,
            key: 'crudDeleteItem',
            body: fullItem,
        });
        crudDispatch({ type: crudState.backTo || 'list' });
    }

    function changeData(data, dataIsValid = null) {
        if (fullItem !== null) {
            setFullItem(data);
            if (dataIsValid !== null) {
                setFormIsValid(dataIsValid);
            }
        }
    }

    const saveIsDisabled = !formIsValid || saving===true;

    const CrudForm = crudState.form || null;
    return (
        <>
            <div className="page-header-title-row">
                <h3>{crudState.title}: Edit</h3>
                <div className="long-buttons">
                    {fullItem !== 'LOADING' && (
                        <ConfirmButton
                            icon="delete"
                            type="negative"
                            onClick={onDelete}
                            title="Delete Organization?"
                            modalContent={`Are you sure you want to delete organization ${fullItem.name ? fullItem.name : ''}?`}
                            labelOk="Yes"
                            labelCancel="No"
                            disabled={saveIsDisabled}>
                            Delete
                        </ConfirmButton>
                    )}
                    <Button icon="cancel" onClick={onCancel}>
                        Cancel
                    </Button>

                    {fullItem !== 'LOADING' && (
                        <Button icon="save" type="positive" onClick={onSave} disabled={saveIsDisabled}>
                            Save
                        </Button>
                    )}
                </div>
            </div>

            <div className="view-body">
                <div className="body-list crud-container">
                    {error === null && fullItem === 'LOADING' && <InnerSpinner />}
                    {error === null && typeof fullItem === 'object' && fullItem !== null && CrudForm !== null && (
                        <CrudForm item={fullItem} onChange={changeData} crudState={crudState} />
                    )}
                    {error !== null && (
                        <>
                            <h2>Error</h2>
                            <p>{error}</p>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
